<template>
  <v-card>
    <v-toolbar dark color="primary" tabs>
      <v-btn icon dark @click="closeForm()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Crear informe') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-if="!disabled" :loading="savingData" dark flat @click="submit">
          {{ $t('Enviar') }}
        </v-btn>
        <v-btn v-if="disabled" :loading="savingData" dark flat @click="closeForm()">
          {{ $t('Cerrar') }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div>
      <v-form ref="reportForm" v-model="valid">
        <v-card class="report-generation-request-form">
          <div class="report-generation-request-form__group">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 pr-3>
                  <v-text-field
                    v-model="formData.name"
                    :disabled="disabled"
                    @input="$emit('input', formData)"
                    :label="$t('Nombredel informe')"
                    :rules="[]"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pr-3>
                  <v-select
                    :disabled="disabled"
                    v-model="formData.type"
                    @input="$emit('input', formData)"
                    :label="$t('Tipo de informe')"
                    :items="typeOptions"
                    :rules="[rules.required]"
                    clearable
                    required
                    item-text="label"
                    item-value="value"
                    box
                    :menu-props="{
                      bottom: true,
                      'offset-y': true,
                    }"
                  ></v-select>
                </v-flex>
                <v-flex xs12 pr-3>
                  <og-simple-date-input
                    v-if="!hideFromToInputs"
                    v-model="formData.request.from"
                    :rules="[rules.required]"
                    required
                    :disabled="disabled"
                    :label="$t('Desde')"
                  ></og-simple-date-input>
                </v-flex>
                <v-flex xs12 pr-3>
                  <og-simple-date-input
                    v-if="!hideFromToInputs"
                    v-model="formData.request.to"
                    :rules="[rules.required]"
                    required
                    :disabled="disabled"
                    :label="$t('Hasta')"
                  ></og-simple-date-input>
                </v-flex>
                <v-flex xs12 pr-3>
                  <v-switch
                    v-if="showInlcudeInactivesInput"
                    v-model="formData.request.include_inactives"
                    :disabled="disabled"
                    :label="$t('Incluir clientes inactivos')"
                  ></v-switch>
                  <v-switch
                    v-if="showInlcudeInactiveCompaniesInput"
                    v-model="formData.request.include_inactives"
                    :disabled="disabled"
                    :label="$t('Incluir empresas inactivas')"
                  ></v-switch>
                  <v-switch
                    v-if="showInlcudeInactiveUsersInput"
                    v-model="formData.request.include_inactive_users"
                    :disabled="disabled"
                    :label="$t('Incluir usuarios inactivos')"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 pr-3>
                  <clavedat-selector
                    v-if="showClavedatInput"
                    v-model="formData.request.clavedat"
                    :disabled="disabled"
                    required
                  ></clavedat-selector>
                </v-flex>
                <v-flex xs12 pr-3>
                  <v-select
                    v-if="showRolenameInput"
                    :disabled="disabled"
                    v-model="formData.request.rolename"
                    @input="$emit('input', formData)"
                    :label="$t('Roles')"
                    :items="rolenameOptions"
                    :rules="[rules.required]"
                    clearable
                    required
                    item-text="label"
                    item-value="value"
                    box
                    :menu-props="{
                      bottom: true,
                      'offset-y': true,
                    }"
                  ></v-select>
                </v-flex>
              </v-layout>

              <template v-if="formData.type === 'seats'">
                <!-- Other extra fields for seats -->
              </template>
              <template v-if="formData.type === 'invoices'">
                <!-- Other extra fields for invoices -->
              </template>

              <v-layout wrap>
                <v-flex xs12>
                  <v-alert
                    v-model="showErrorFormMessage"
                    border="left"
                    color="red"
                    dismissible
                    elevation="2"
                    prominent
                    outline
                    type="error"
                  >
                    {{ errorFormMessage }}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-btn @click="closeForm()">
              {{ $t('Cancelar') }}
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn v-if="!disabled" :loading="savingData" @click="submit()">
              {{ $t('Enviar') }}
            </v-btn>
            <v-btn v-if="disabled" @click="closeForm()">
              {{ $t('Cerrar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import OgSimpleDateInput from '@/components/commons/form/inputs/OgSimpleDateInput.vue';
import ClavedatSelector from '@/components/commons/form/inputs/ClavedatSelector.vue';

// const moment = require('moment');

export default {
  components: {
    OgSimpleDateInput,
    ClavedatSelector,
  },
  props: {
    editForm: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          name: null,
          type: null,
          request: {
            from: null,
            to: null,
            include_inactives: null,
            include_inactive_users: null,
            rolename: null,
            clavedat: null,
          },
        };
      },
    },
  },
  data() {
    return {
      valid: true,
      savingData: false,
      showErrorFormMessage: false,
      errorFormMessage:
        'Hay errores en el formulario, comprueba que todos los campos estén correctamente rellenados',
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      typeOptions: [
        { label: 'Clientes en aplifisa', value: 'aplifisa-clients' },
        { label: 'Consultores asignados', value: 'assigned-consultants' },
        { label: 'Autónomos: Ingresos gastos y beneficios', value: 'igb-autonomos' },
        { label: 'Autónomos: Facturas', value: 'invoices-autonomos' },
        { label: 'Sociedades: Ingresos gastos y beneficios', value: 'igb-empresas' },
        { label: 'Sociedades: Asientos contables y facturas', value: 'seats-empresas' },
        { label: 'Pérdidas y Ganancias', value: 'pyg' },
        { label: 'Conversaciones por consultor ', value: 'threads-consultant-report' },
        { label: 'Usuarios y roles', value: 'users' },
        { label: 'Usuarios en cada empresa', value: 'users-in-companies' },
      ],
      rolenameOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Consultores', value: 'consultant' },
        { label: 'Pymes', value: 'pyme' },
        { label: 'Autónomos', value: 'autonomous' },
        { label: 'Con empleados', value: 'employees' },
        { label: 'LOPD', value: 'lopd' },
      ],
    };
  },
  computed: {
    hideFromToInputs() {
      const showWhenTypeIn = [
        'aplifisa-clients',
        'assigned-consultants',
        'users',
        'users-in-companies',
      ];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    showInlcudeInactivesInput() {
      const showWhenTypeIn = ['aplifisa-clients', 'assigned-consultants', 'users'];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    showInlcudeInactiveCompaniesInput() {
      const showWhenTypeIn = ['users-in-companies'];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    showInlcudeInactiveUsersInput() {
      const showWhenTypeIn = ['users-in-companies'];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    showClavedatInput() {
      const showWhenTypeIn = ['pyg'];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    showRolenameInput() {
      const showWhenTypeIn = ['assigned-consultants', 'users'];
      return this.formData.type && showWhenTypeIn.includes(this.formData.type);
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    submit() {
      this.addExtraFields();
      const validate = this.validateForm();

      if (validate) {
        this.$emit('submit', this.formData);
      }
    },
    addExtraFields() {},
    validateForm() {
      this.showErrorFormMessage = false;
      const res = this.$refs.reportForm.validate();

      if (!res) {
        this.showErrorFormMessage = true;
      }

      return res;
    },
    closeForm() {
      console.log('Close form');
      this.$emit('close-form');
    },
  },
  watch: {},
};
</script>

<style lang="sass"></style>
